import { render } from "./JsonTextareas.vue?vue&type=template&id=aaae4728"
import script from "./JsonTextareas.vue?vue&type=script&lang=js"
export * from "./JsonTextareas.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__